import { useNavigate } from 'react-router-dom'
import { Home } from 'lucide-react'

export function NotFound() {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center">
      <div className="section-padding">
        <div className="container-max">
          <div className="max-w-2xl mx-auto text-center">
            <div className="card p-12">
              {/* Content */}
              <div className="mb-8">
                <h1 className="text-3xl font-serif text-primary-900 mb-4">
                  Oops! Page Not Found
                </h1>
                <p className="text-lg text-neutral-600 mb-2">
                  The page you're looking for doesn't exist or you don't have access to it.
                </p>
              </div>

              {/* CTA Button */}
              <button
                onClick={handleGoHome}
                className="btn-primary inline-flex items-center gap-2 px-8 py-3 text-lg"
              >
                <Home className="h-5 w-5" />
                Go Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
